<template>
    <div>
        <canvas ref="chart" style="height: 300px;"/>
    </div>
</template>

<script>
import Chartisan from '../../libraries/chart/chartisan';
import ChartisanHooks from '../../libraries/chart/chartisan-hooks';

export default {
  name: 'AnalysisChart',

  data: () => {
    const today = new Date();
    const startDate = new Date(new Date().setDate(today.getDate() - 90));

    const pad = function (n, width, z = '0') {
      n = `${n}`;
      return n.length >= width
        ? n
        : new Array(width - n.length + 1).join(z) + n;
    };

    return {
      chart: undefined,
      startDate: `${startDate.getFullYear()}-${pad(
        startDate.getMonth() + 1,
        2,
      )}-${pad(startDate.getDate(), 2)}`,
      endDate: `${today.getFullYear()}-${pad(
        today.getMonth() + 1,
        2,
      )}-${pad(today.getDate(), 2)}`,
    };
  },

  computed: {
    url() {
      return `/api/chart/data_analysis${document.location.search}`;
    },
  },

  mounted() {
    this.chart = new Chartisan({
      el: this.$refs.chart,
      url: this.url,
      hooks: new ChartisanHooks()
        .tooltip(true)
        .legend({
          display: true,
          position: 'bottom',
        })
        .datasets([{ type: 'line' }]),
    });
  },

  methods: {
    updateGraph() {
      // This is a ugly hack to get it to refresh without an error
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.chart = new Chartisan({
            el: this.$refs.chart,
            url: this.url,
            hooks: new ChartisanHooks()
              .tooltip(true)
              .legend({
                display: true,
                position: 'bottom',
              })
              .datasets([{ type: 'line' }]),
          });
        });
      });
    },
  },
};
</script>
